import * as types from './actionTypes';  
import callBraggartApi from '../api/callBraggartApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';


export function doCallBraggartRes(data) {  
  return {
    type: types.DO_CALL_BRAGGART_RES, 
    data
  };
}
export function uploadBraggart(ids) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      callBraggartApi.doCallBraggart(ids).then(data => {
        dispatch(doCallBraggartRes(data));
        dispatch(doCallBraggartRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}